import { ErrorResponse } from "@gtpl/shared-models/common-models";
import { TeamCalenderResponse } from "@gtpl/shared-models/hrms";
import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { Between, Repository } from "typeorm";
import { TeamCalenderDto } from "./dto/team-calender.dto";
import { TeamCalenderRequest } from "./dto/team-calender.request";
import { TeamCalender } from "./entity/team-calender.entity";
import { TeamCalenderAdapter } from "./team-calender.adapter";
import { TeamCalenderRepository } from "./repository/team-calender.repository";
import { ShiftCodeReq } from "./dto/shift-code.request";
import moment from "moment";
import { CommonResponse } from "@gtpl/shared-models/masters";

@Injectable()
export class TeamCalenderService {

    constructor(

        private teamcalenderRepository: TeamCalenderRepository,
        private teamcalenderAdapter: TeamCalenderAdapter,
    ) { }

    async getTeamCalenderWithoutRelations(id: number): Promise<TeamCalender> {
        const teamcalenderResponse = await this.teamcalenderRepository.findOne({
            where: { id: id },
        });
        if (teamcalenderResponse) {
            return teamcalenderResponse;
        } else {
            return null;
        }
    }

    async getTeamCalenderDateBetween(shiftCode: string, fromDate: Date, toDate: Date): Promise<CommonResponse> {
        const teamcalenderResponse = await this.teamcalenderRepository.find({
            where: { shiftCode: shiftCode }, select: ['fromDate', 'toDate']
        });
        for (const record of teamcalenderResponse) {
            const checkFrmData = moment(fromDate).isBetween(record.fromDate, record.toDate)
            if (checkFrmData) return new CommonResponse(false, 1111, 'Selected dates already assigned for this shift group code');
            const checkToDate = moment(toDate).isBetween(record.fromDate, record.toDate);
            if (checkToDate) return new CommonResponse(false, 1111, 'Selected dates already assigned for this shift group code')
        }
        return new CommonResponse(true, 11111, 'Validated')

    }

    async createTeamCalender(teamcalenderDTO: TeamCalenderDto, isUpdate: boolean): Promise<TeamCalenderResponse> {
        try {
            if (!isUpdate) {
                const teamcalenderEntity = await this.getTeamCalenderWithoutRelations(teamcalenderDTO.id);
                if (teamcalenderEntity) {
                    throw new ErrorResponse(11104, 'Team Calender already exists');
                }
            }
            if (!isUpdate) {
                const teamcalenderEntity = await this.getTeamCalenderDateBetween(teamcalenderDTO.shiftCode, teamcalenderDTO.fromDate, teamcalenderDTO.toDate)
                if (!teamcalenderEntity.status) {
                    return new CommonResponse(false, 11111, teamcalenderEntity.internalMessage);
                }
            }
            else {
                const teamcalenderEntity = await this.getTeamCalenderWithoutRelations(teamcalenderDTO.id);
                if (teamcalenderEntity) {
                    if (teamcalenderEntity.id != teamcalenderDTO.id) {
                        throw new ErrorResponse(11104, 'Team Calender already exists')
                    }
                }
            }
            const convertedEntity: TeamCalender = this.teamcalenderAdapter.convertDtoToEntity(teamcalenderDTO, isUpdate);
            const savedEntity: TeamCalender = await this.teamcalenderRepository.save(convertedEntity);
            const savedDto: TeamCalenderDto = this.teamcalenderAdapter.convertEntityToDto(savedEntity);
            if (savedDto) {
                const response = new TeamCalenderResponse(true, 1, isUpdate ? 'Team Calender Updated Successfully' : 'Team Calender Created Successfully');
                return response;
            } else {
                throw new ErrorResponse(11106, 'Team Calender saved but issue while transforming it into DTO');
            }
        } catch (error) {
            throw error;
        }
    }

    async getAllTeamCalender(): Promise<TeamCalenderResponse> {
        try {
            const teamcalenderDtos: TeamCalenderDto[] = [];
            const teamcalenderEntities: TeamCalender[] = await this.teamcalenderRepository.find({ order: { id: 'ASC' } });
            if (teamcalenderEntities) {
                teamcalenderEntities.forEach(Entity => {
                    const convertedDto: TeamCalender = this.teamcalenderAdapter.convertEntityToDto(Entity);
                    teamcalenderDtos.push(convertedDto);
                });
                const response = new TeamCalenderResponse(true, 1, 'Team Calender Retrieved Successfully', teamcalenderDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }


    async getAllActiveTeamCalender(): Promise<TeamCalenderResponse> {
        try {
            const teamcalenderDtos: TeamCalenderDto[] = [];
            const teamcalenderEntities: TeamCalender[] = await this.teamcalenderRepository.find({ order: { id: 'ASC' }, where: { isActive: true }, });
            if (teamcalenderEntities) {
                teamcalenderEntities.forEach(Entity => {
                    const convertedEntity: TeamCalender = this.teamcalenderAdapter.convertEntityToDto(Entity);
                    teamcalenderDtos.push(convertedEntity);
                });
                const response = new TeamCalenderResponse(true, 11108, 'Active Team Calender Retrieved Successfully', teamcalenderDtos);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getTeamCalenderRecords(req: ShiftCodeReq): Promise<TeamCalenderResponse> {
        try {
            const teamcalenderDtos: TeamCalenderDto[] = [];
            console.log(req);
            const teamcalenderEntities = await this.teamcalenderRepository.find({ order: { id: 'ASC' }, where: { isActive: true, shiftCode: req.shiftCode } });
            console.log(teamcalenderEntities);
            if (teamcalenderEntities) {
                teamcalenderEntities.forEach(Entity => {
                    const convertedEntity = this.teamcalenderAdapter.convertEntityToDto(Entity);
                    teamcalenderDtos.push(convertedEntity);
                });
                console.log(teamcalenderDtos, 'A');
                return new TeamCalenderResponse(true, 11108, 'Active Team Calender Retrieved Successfully', teamcalenderDtos);
            } else {
                throw new ErrorResponse(99998, 'Data Not Found');
            }
        } catch (err) {
            throw err;
        }
    }

    async getTeamCalenderById(id: number): Promise<TeamCalender> {
        const response = await this.teamcalenderRepository.findOne({
            where: { id: id },
        });
        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async activateOrDeactivateTeamCalender(teamcalenderReq: TeamCalenderRequest): Promise<TeamCalenderResponse> {
        try {
            const teamcalenderExists = await this.getTeamCalenderById(teamcalenderReq.id);
            if (teamcalenderExists) {
                if (teamcalenderReq.versionFlag != teamcalenderExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current team calender information. Refresh and try again');
                } else {
                    const teamcalenderStatus = await this.teamcalenderRepository.update(
                        { id: teamcalenderReq.id },
                        { isActive: teamcalenderReq.isActive, updatedUser: teamcalenderReq.updatedUser }
                    );
                    if (teamcalenderExists.isActive) {
                        if (teamcalenderStatus.affected) {
                            const teamcalenderResponse: TeamCalenderResponse = new TeamCalenderResponse(true, 10115, 'team calender is de-activated successfully');
                            return teamcalenderResponse;
                        } else {
                            throw new ErrorResponse(10111, ' team calender is already de-activated');
                        }
                    } else {
                        if (teamcalenderStatus.affected) {
                            const teamcalenderResponse: TeamCalenderResponse = new TeamCalenderResponse(true, 10114, 'team calender is activated successfully');
                            return teamcalenderResponse;
                        } else {
                            throw new ErrorResponse(10112, 'team calender is already activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}